import * as React from 'react';
import { IDs } from '../../../../helpers/IDs';
import { MehrsprachigkeitMUI } from './MehrsprachigkeitMUI';

interface MehrsprachigkeitStatischeInhalteProps extends React.ClassAttributes<any> {
    data: any;
}

interface MehrsprachigkeitStatischeInhalteState {
    itemList: any; // { 'list name' : [ items ] }
}

export class MehrsprachigkeitStatischeInhalte extends React.Component<MehrsprachigkeitStatischeInhalteProps, MehrsprachigkeitStatischeInhalteState> {

    constructor(props: any) {
        super(props);
        this.state = {
            itemList: null
        };
    }

    private intern_key2 = 'sys';

    componentDidMount(): void {
        this.init();
    }

    componentDidUpdate(prevProps: Readonly<MehrsprachigkeitStatischeInhalteProps>, prevState: Readonly<MehrsprachigkeitStatischeInhalteState>, snapshot?: any): void {
        if (this.props.data[IDs.ENT_MEHRSPRACHIGKEIT] && prevProps.data[IDs.ENT_MEHRSPRACHIGKEIT] &&
            this.props.data[IDs.ENT_MEHRSPRACHIGKEIT].length !== prevProps.data[IDs.ENT_MEHRSPRACHIGKEIT].length) {
            this.init();
        }
    }

    init(): void {
        const itemList: any = {};
        itemList[''] = (this.props.data[IDs.ENT_MEHRSPRACHIGKEIT] || [])
            .filter((r: any) => r.intern_key2 === this.intern_key2)
            .sort((a: any, b: any) => a.intern_key > b.intern_key ? 1 : a.intern_key < b.intern_key ? -1 : 0)
            .map((r: any) => {
                return { name: r.intern_key };
            });
        this.setState({ itemList });
    }

    render(): JSX.Element {
        return (
            <MehrsprachigkeitMUI
                data={this.props.data}
                intern_key2={this.intern_key2}
                itemList={this.state.itemList}
            />
        );
    }
}
